import { useEffect, useState } from "react";

import { api } from "@/api";

export const RecycleDiagnostic = ({ message }) => {
  const [diag, setDiag] = useState(null);
  useEffect(() => { api.get("/recycle/diagnostic").then(({ data }) => setDiag(data)).catch(() => setDiag({})); }, []);
  return (
    <div className="rc-error" data-testid="recycle-load-error">
      <p style={{ margin: 0 }}>{message}</p>
      {diag === null && <p style={{ margin: "8px 0 0" }}>Diagnostic en cours…</p>}
      {diag?.egress_ip && (
        <p style={{ margin: "8px 0 0" }} data-testid="recycle-egress-ip">
          IP sortante de ce serveur : <strong>{diag.egress_ip}</strong> — à autoriser (/32, port 5432) dans le groupe de sécurité AWS RDS.
          {diag.error && <> Cause détectée : {diag.error}.</>}
        </p>
      )}
    </div>
  );
};
